import { defineMessage, defineMessages, MessageDescriptor } from 'react-intl';

/**
 * GIP report export modal messages (Spanish defaults from es.json).
 */
export const gipExportMessages: Record<string, MessageDescriptor> = defineMessages({
  title: {
    id: 'audit.gipReport.export.title',
    defaultMessage: 'Exportar reporte de evidencia',
  },
  startBtn: {
    id: 'audit.gipReport.export.startBtn',
    defaultMessage: 'Iniciar',
  },
  retryBtn: {
    id: 'audit.gipReport.export.retryBtn',
    defaultMessage: 'Exportar nuevamente',
  },
  startNotification: {
    id: 'audit.gipReport.export.startNotification',
    defaultMessage: 'Export iniciado',
  },
  startNotificationError: {
    id: 'audit.gipReport.export.startNotificationError',
    defaultMessage: 'No se pudo iniciar el export',
  },
});

/** Label for seconds to include before an audio match. */
export const audioMatchIncludeBeforeLabelMessage = defineMessage({
  id: 'audit.gipReport.export.audioMatchIncludeBeforeLabel',
  defaultMessage: 'Segundos a incluir antes del match',
});

/** Label for seconds to include after an audio match. */
export const audioMatchIncludeAfterLabelMessage = defineMessage({
  id: 'audit.gipReport.export.audioMatchIncludeAfterLabel',
  defaultMessage: 'Segundos a incluir después del match',
});

/** Helper text describing the allowed range for audio match include seconds. */
export const audioMatchIncludeHelperMessage = defineMessage({
  id: 'audit.gipReport.export.audioMatchIncludeHelper',
  defaultMessage: 'Entre 0 y 300 segundos',
});
